import Vue from 'vue';
import App from '@/apps/MainApp.vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import '@/plugins/log';
import '@/assets/styles.css';
import Vuex from 'vuex'
import store from "@/store";

Vue.config.productionTip = false;

Vue.use(Vuex)

new Vue({
  vuetify,
  i18n: i18n.vueI18n,
  render: h => h(App),
  store: store
}).$mount('#app');
